<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :get-data-func="getOrgs"
      :headers="headers"
      @click:row="goDetails($event.item)"
      clickable
      init-sort-by="name"
      ref="dataTable"
      title-text="单位列表"
      v-model="selected"
      search-text="搜索单位名称"
    >
      <!--<template slot="title-action">
        <l-option-menu
          :options="moreActions"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>-->
     <!-- <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="deleteOrg(item)" icon>
            <v-icon small>$vuetify.icons.delete</v-icon>
          </v-btn>
        </td>
      </template>-->
    </l-data-table>
      <!--<v-layout>-->
        <!--<v-flex xs4 class="py-3">-->
          <!--<l-action-card icon="$vuetify.icons.group" label="管理用户组类型"></l-action-card>-->
        <!--</v-flex>-->
      <!--</v-layout>-->

    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
// import {time} from '../../../ladmin/utils'
// import LActionCard from '../../../components/LActionCard'
import defaults from '../../../consts'
export default {
  name: 'OrganizationList',
  // components: {LActionCard},
  data: () => ({
    selected: [],
    floatingButton: false,
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'bindGroup',
      //   label: '批量绑定分组类型',
      //   icon: '$vuetify.icons.group'
      // },
      // {
      //   event: 'bindRole',
      //   label: '批量绑定角色',
      //   icon: '$vuetify.icons.role'
      // },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    headers: defaults.userAdmin.GROUP_HEADERS,
  }),
  methods: {
    async getOrgs ({pagination, sortStack, filterItems, search}) {
      let res = await this.$store.dispatch('userAdmin/getOrgListByName', {
        pagination,
        name: search,
        id: '',
        type: 'org'
      })
      console.log(res)
      if (res.data.status === 1) {
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('查询单位信息失败，原因:' + res.data.msg)
      }
    },
    refresh () {
      if (this.$refs.dataTable) {
        this.$refs.dataTable.refresh()
      }
    },
    async deleteOrg (org) {
      // console.log(user)
      if (!org) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该单位？',
        text: org.name || `N/A`,
      })
      if (res) {
        try {
          await this.$store.dispatch('userAdmin/deleteGroups', [org])
          this.refresh()
          this.$L.alert('success', {message: '删除成功'})
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
      }
      close()
    },
    goDetails (item, force) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'OrgDetails',
          params: {name: item.name},
          query: {id: item.id}
        })
      }
    },
    goNew () {
      this.$router.push({
        name: 'NewOrg'
      })
    }
  }
}
</script>

<style scoped>

</style>
